(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    function initCustomCarouselAutoplay() {

  const containers = document.querySelectorAll(".force-full-width");

  containers.forEach((container) => {

    /*
     * מונע הפעלה כפולה של הטיימר
     */
    if (container.dataset.customAutoplayInitialized === "true") {
      return;
    }

    container.dataset.customAutoplayInitialized = "true";


    /*
     * בדיקה האם Autoplay מופעל
     */
    const autoplay = container.dataset.autoplay === "true";

    if (!autoplay) {
      return;
    }


    /*
     * מהירות המעבר
     */
    const autoplaySpeed =
      parseInt(container.dataset.autoplaySpeed, 10) || 1000;


    /*
     * מציאת הקרוסלה
     */
    const slideshow =
      container.querySelector("slideshow-component");

    if (!slideshow) {
      return;
    }


    /*
     * מציאת האזור שזז בפועל
     */
    const slidesContainer =
      slideshow.querySelector("slideshow-slides");

    if (!slidesContainer) {
      return;
    }


    /*
     * מציאת כל הכרטיסים / התמונות
     */
    const slides =
      Array.from(slidesContainer.querySelectorAll(":scope > .card"));

    if (slides.length <= 1) {
      return;
    }


    let currentIndex = 0;
    let isResetting = false;


    /*
     * מציאת הכרטיס הקרוב ביותר
     * למיקום הנוכחי של הקרוסלה
     */
    function updateCurrentIndex() {

      const currentScroll = slidesContainer.scrollLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {

        const distance =
          Math.abs(slide.offsetLeft - currentScroll);

        if (distance < closestDistance) {

          closestDistance = distance;
          closestIndex = index;

        }

      });

      currentIndex = closestIndex;

    }


    /*
     * מעבר לתמונה הבאה
     */
    function goToNextSlide() {

      if (isResetting) {
        return;
      }

      updateCurrentIndex();

      let nextIndex = currentIndex + 1;


      /*
       * אם הגענו לסוף -
       * חוזרים להתחלה
       */
      if (nextIndex >= slides.length) {

        isResetting = true;

        slidesContainer.scrollTo({
          left: 0,
          behavior: "smooth"
        });

        currentIndex = 0;

        setTimeout(() => {
          isResetting = false;
        }, 600);

        return;

      }


      /*
       * מעבר של תמונה אחת בדיוק
       */
      const targetSlide = slides[nextIndex];

      slidesContainer.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: "smooth"
      });

      currentIndex = nextIndex;

    }


    /*
     * הפעלה כל X שניות
     */
    const autoplayInterval =
      setInterval(goToNextSlide, autoplaySpeed);


    /*
     * אם המשתמש מזיז ידנית,
     * אנחנו מעדכנים את המיקום
     */
    slidesContainer.addEventListener(
      "scrollend",
      updateCurrentIndex
    );


    /*
     * שמירת ה-Interval במקרה
     * שנרצה לעצור אותו בעתיד
     */
    container.dataset.autoplayInterval = autoplayInterval;

  });

}


/*
 * טעינה רגילה של האתר
 */
if (document.readyState === "loading") {

  document.addEventListener(
    "DOMContentLoaded",
    initCustomCarouselAutoplay
  );

} else {

  initCustomCarouselAutoplay();

}


/*
 * חשוב ל-Shopify Theme Editor
 * כדי שהקרוסלה תעבוד גם אחרי
 * עריכת הסקשן בלי רענון הדף
 */
document.addEventListener(
  "shopify:section:load",
  initCustomCarouselAutoplay
);
  } catch(e) { console.error(e); }
})();

})();
